@if (images().length > 0) {
  <div
    class="fixed inset-0 z-[80] flex items-center justify-center bg-black/30 p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'IMAGE_VIEWER_DIALOG_LABEL' | translate"
    (click)="onBackdropClick()"
    (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)">
    <!-- Envoltura para el foco y el trap; fija el ancho del diálogo (w-full no funciona con display:contents) -->
    <div #viewerContent tabindex="-1" class="w-full max-w-4xl max-h-[92vh] outline-none" (click)="$event.stopPropagation()">
      <app-dialog-shell
        [icon]="'fa-image'"
        [title]="name ?? ('IMAGE_VIEWER_DIALOG_LABEL' | translate)"
        rootClass="h-full"
        bodyClass="bg-base-200/60 p-4 flex items-center justify-center"
        (closed)="close()">
        <!-- Acciones de cabecera: navegación + contador -->
        @if (images().length > 1) {
          <button
            type="button"
            header-actions
            class="btn btn-sm btn-circle btn-ghost text-white hover:bg-white/10"
            (click)="goTo(index() - 1)"
            [attr.aria-label]="'IMAGE_VIEWER_PREVIOUS' | translate">
            <i class="fa fa-chevron-left"></i>
          </button>
        }
        <span header-actions class="bg-white/10 text-white text-xs font-medium rounded-full px-3 py-1 tabular-nums" aria-live="polite">
          {{ 'IMAGE_VIEWER_COUNTER' | translate: { current: index() + 1, total: images().length } }}
        </span>
        @if (images().length > 1) {
          <button
            type="button"
            header-actions
            class="btn btn-sm btn-circle btn-ghost text-white hover:bg-white/10"
            (click)="goTo(index() + 1)"
            [attr.aria-label]="'IMAGE_VIEWER_NEXT' | translate">
            <i class="fa fa-chevron-right"></i>
          </button>
        }

        <!-- Cuerpo: selector de línea encima de la pizarra + imagen -->
        <div class="flex flex-col items-center gap-2" (click)="$event.stopPropagation()">
          <!-- Selector de línea de ejercicio (Original / Alternativa N) justo encima de la pizarra -->
          @if (lineOptions().length > 1) {
            <div class="flex flex-wrap gap-1.5 justify-center px-3">
              @for (opt of lineOptions(); track opt.index) {
                <button
                  type="button"
                  class="btn btn-xs shadow"
                  [class.btn-primary]="opt.index === lineIndex()"
                  [class.btn-ghost]="opt.index !== lineIndex()"
                  [class.bg-base-100/90]="opt.index !== lineIndex()"
                  (click)="selectLine(opt.index)">
                  {{ opt.label }}
                </button>
              }
            </div>
          }
          <img
            [src]="currentImage"
            [alt]="'IMAGE_VIEWER_COUNTER' | translate: { current: index() + 1, total: images().length }"
            class="max-h-[65vh] rounded-lg shadow border-4 border-white transition-opacity duration-200 select-none"
            [class.opacity-0]="!imageLoaded()"
            (load)="onImageLoad()"
            style="touch-action: pan-y" />
        </div>

        <!-- Pie: acciones -->
        @if (currentAnimation) {
          <button
            footer
            type="button"
            class="btn btn-sm btn-secondary"
            (click)="viewAnimation()"
            [attr.aria-label]="'IMAGE_VIEWER_VIEW_ANIMATION' | translate"
            [title]="'IMAGE_VIEWER_VIEW_ANIMATION' | translate">
            <i class="fa fa-play-circle"></i>
            <span class="hidden sm:inline">{{ 'IMAGE_VIEWER_VIEW_ANIMATION' | translate }}</span>
          </button>
        }
        <button
          footer
          type="button"
          class="btn btn-sm btn-primary"
          (click)="downloadImage()"
          [attr.aria-label]="'IMAGE_VIEWER_DOWNLOAD' | translate"
          [title]="'IMAGE_VIEWER_DOWNLOAD' | translate">
          <i class="fa fa-download"></i>
          <span class="hidden sm:inline">{{ 'IMAGE_VIEWER_DOWNLOAD' | translate }}</span>
        </button>
        @if (images().length > 1) {
          <button
            footer
            type="button"
            class="btn btn-sm btn-accent"
            [disabled]="downloadingAll()"
            (click)="downloadAllImages()"
            [attr.aria-label]="'IMAGE_VIEWER_DOWNLOAD_ALL' | translate"
            [title]="'IMAGE_VIEWER_DOWNLOAD_ALL' | translate">
            @if (downloadingAll()) {
              <span class="loading loading-spinner loading-sm"></span>
            } @else {
              <i class="fa fa-file-archive"></i>
            }
            <span class="hidden sm:inline">{{ 'IMAGE_VIEWER_DOWNLOAD_ALL' | translate }}</span>
          </button>
        }
      </app-dialog-shell>
    </div>
  </div>
}
